import { Injectable } from '@angular/core';
import { Process } from './process';
import { HttpClient } from '@angular/common/http';
import { StorageUtils } from '../../../utils/storage-utils';
import { RestService } from '../../../utils/rest-service';
import { JsonContainer } from '../../../utils/json-container';

@Injectable()
export class ZapSignService extends RestService {

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'zapSign', storageUtils);
    }

    createDoc(processId: string, callback: (result: JsonContainer, link: string) => void) {
        this.executeGet(`createDoc/${processId}`, callback)
    }

    createCancelDoc(processId: string, callback: (result: JsonContainer, link: string) => void) {
        this.executeGet(`createCancelDoc/${processId}`, callback)
    }

    getDoc(token: string, callback: (result: JsonContainer, link: any) => void) {
        this.executeGet(`getDoc/${token}`, callback)
    }


}
